import { APP_ENV } from '~/lib/api-config'
import type { EventClient } from '~/lib/types/EventClient'
import type { EventClientConfig } from '~/lib/types/Event'
import { HttpEventClient } from './HttpEventClient'
import { MockEventClient } from './MockEventClient'

const DEFAULT_CONFIG: EventClientConfig = {
  baseUrl: 'https://events.toridori.me',
  bufferSize: 10,
  flushIntervalMs: 30 * 1000, // 30秒
  maxRetries: 3,
  backoffBaseMs: 1000, // 1秒
  storageKey: 'toridori_failed_events',
  concurrency: 5,
}

function createEventClient(config: Partial<EventClientConfig> = {}): EventClient {
  const finalConfig = { ...DEFAULT_CONFIG, ...config }

  if (APP_ENV === 'local' || process.env.NODE_ENV === 'test') {
    return new MockEventClient()
  }

  return new HttpEventClient(finalConfig)
}

let eventClientInstance: EventClient | null = null

export function getEventClient(): EventClient {
  if (!eventClientInstance) {
    const baseUrl =
      APP_ENV === 'development'
        ? 'https://events.xdev.toridori.me'
        : APP_ENV === 'qa'
          ? 'https://events.qa.toridori.me'
          : DEFAULT_CONFIG.baseUrl
    eventClientInstance = createEventClient({ baseUrl })
  }
  return eventClientInstance
}

export function setEventClient(client: EventClient): void {
  eventClientInstance = client
}

export function resetEventClient(): void {
  if (eventClientInstance) {
    eventClientInstance.destroy()
    eventClientInstance = null
  }
}

export * from './HttpEventClient'
export * from './MockEventClient'
export * from './EventBuffer'
export * from './RetryManager'
export * from './EventStorage'
